import { Fragment, useEffect, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputBox from "../../../components/input-box";
import { api } from "../../../services/axios";

export default function CreateMemberModal({
  visible,
  setVisible,
  org_salesforce_id,
  activity,
  colleges,
}: {
  activity: string;
  org_salesforce_id: string;
  colleges?: string[];
  visible: boolean;
  setVisible: (val: boolean) => void;
}) {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      first_name: "",
      last_name: "",
      number: "",
      college: colleges && colleges.length ? colleges[0] : null,
      status: "active",
      salesforce_id: "",
    },
    validationSchema: Yup.object({
      first_name: Yup.string().min(1).max(200).required("Required"),
      last_name: Yup.string().min(1).max(200).required("Required"),
      number: Yup.string().min(1).max(30).required("Required"),
      salesforce_id: Yup.string().min(1).max(30).required("Required"),
      status: Yup.string().required("Required"),
    }),
    onSubmit: async (formData) => {
      try {
        await api
          .post("athletes", {
            ...formData,
            org_salesforce_id: org_salesforce_id,
            college_salesforce_id:
              colleges && colleges.length ? colleges[0] : null,
            activity: activity,
            full_name: formData.first_name + " " + formData.last_name,
            email: "",
            phone: "",
          })
          .then((res) => {
            console.log(res);
          })
          .catch((error) => {
            console.log(error);
          });

        setVisible(false);
        formik.resetForm();
      } catch (e: any) {
        console.log("ERORR", e);
      }
    },
  });

  useEffect(() => {
    formik.resetForm();
  }, []);
  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root show={visible} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-10 inset-0 overflow-y-auto"
        initialFocus={cancelButtonRef}
        onClose={setVisible}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="relative inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="text-lg leading-6 font-medium text-gray-900"
                    >
                      Add a new member
                    </Dialog.Title>
                    <div className="my-2 mb-4">
                      <p className="text-sm text-gray-500">
                        Add a new member to your organisation
                      </p>
                    </div>
                    <div className="mt-2 w-full">
                      <InputBox
                        type="text"
                        placeholder="First name"
                        label="First Name"
                        name={formik.getFieldProps("first_name").name}
                        value={formik.getFieldProps("first_name").value}
                        onChange={formik.getFieldProps("first_name").onChange}
                        onBlur={formik.getFieldProps("first_name").onBlur}
                        touched={formik.touched.first_name}
                        error={formik.errors.first_name}
                      />
                      <InputBox
                        type="text"
                        placeholder="Last name"
                        label="Last name"
                        name={formik.getFieldProps("last_name").name}
                        value={formik.getFieldProps("last_name").value}
                        onChange={formik.getFieldProps("last_name").onChange}
                        onBlur={formik.getFieldProps("last_name").onBlur}
                        touched={formik.touched.last_name}
                        error={formik.errors.last_name}
                      />
                      <InputBox
                        type="text"
                        placeholder="Number"
                        label="Number"
                        name={formik.getFieldProps("number").name}
                        value={formik.getFieldProps("number").value}
                        onChange={formik.getFieldProps("number").onChange}
                        onBlur={formik.getFieldProps("number").onBlur}
                        touched={formik.touched.number}
                        error={formik.errors.number}
                      />
                      <InputBox
                        type="text"
                        placeholder="Salesforce ID"
                        label="Salesforce ID"
                        name={formik.getFieldProps("salesforce_id").name}
                        value={formik.getFieldProps("salesforce_id").value}
                        onChange={
                          formik.getFieldProps("salesforce_id").onChange
                        }
                        onBlur={formik.getFieldProps("salesforce_id").onBlur}
                        touched={formik.touched.salesforce_id}
                        error={formik.errors.salesforce_id}
                      />
                      <div>
                        <label
                          htmlFor="location"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Status
                        </label>
                        <select
                          id="status"
                          name={formik.getFieldProps("status").name}
                          className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                          value={formik.getFieldProps("status").value || ""}
                          onChange={formik.getFieldProps("status").onChange}
                          onBlur={formik.getFieldProps("status").onBlur}
                        >
                          <option>active</option>
                          <option>inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={formik.submitForm}
                >
                  Create
                </button>
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => setVisible(false)}
                  ref={cancelButtonRef}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
